module.exports = __webpack_public_path__ + "img/Vector16.83bd51a9.svg";